import { GetStatement_listStatements_installmentsOverdue } from '../types/GetStatement'
import { getOrFailUrlAndBarcodeBankSlip } from './getUrlAndBarcodeBankSlip'

interface Installment extends GetStatement_listStatements_installmentsOverdue {}

export const getManyUrlsAndBarCodeBankSlips = async (installments: Installment[]) => {
  try {
    const response = await Promise.all(
      installments.map(async installment => {
        try {
          return {
            installment: await getOrFailUrlAndBarcodeBankSlip(installment),
            success: true,
          }
        } catch (e) {
          console.log('error getManyUrlsAndBarCodeBankSlips', e)
          return {
            installment,
            success: false,
          }
        }
      })
    )
    return response
  } catch (e) {
    console.log('not found url or barcode to bank slip', e)
  }
}
